import React, { useRef, useEffect, useCallback, useContext } from "react";
import { Link } from "react-router-dom";
import logoImg from "../img/smallLogo.png";
import { ThemeContext } from "../context/ThemeContext";

function SelectPage() {
  const selectMyRef = useRef(null);
  const selectYourRef = useRef(null);
  const selectMyButtonRef = useRef(null);
  const selectYourButtonRef = useRef(null);
  const {
    selectMyState,
    setselectMyState,
    selectYourState,
    setselectYourState,
  } = useContext(ThemeContext);
  const submitButtonRef = useRef(null);

  const selectBoxHandler = (e) => {
    setselectMyState(e.target.value);
    selectMyButtonRef.current.value = e.target.value;
    // console.log("MY 변경 value : ", selectMyButtonRef.current.value);
    selectMyRef.current.classList.remove("active");
  };

  const selectBoxHandler2 = (e) => {
    setselectYourState(e.target.value);
    selectYourButtonRef.current.value = e.target.value;
    // console.log("YOUR 변경 value : ", selectYourButtonRef.current.value);
    selectYourRef.current.classList.remove("active");
  };

  // 결과화면 button 이벤트
  const alertEvent = useCallback((event) => {
    event.preventDefault();
    alert("MBTI를 선택해주세요!");
  }, []);

  useEffect(() => {
    // className remove
    selectMyButtonRef.current.addEventListener("click", () => {
      selectYourRef.current.classList.remove("active");
    });
    selectYourButtonRef.current.addEventListener("click", () => {
      selectMyRef.current.classList.remove("active");
    });

    // select 조건에 따른 이벤트
    if (
      selectMyButtonRef.current.value === "mbti" &&
      selectYourButtonRef.current.value === "mbti"
    ) {
      submitButtonRef.current.addEventListener("click", alertEvent);
    } else if (
      selectMyButtonRef.current.value !== "mbti" &&
      selectYourButtonRef.current.value !== "mbti"
    ) {
      submitButtonRef.current.classList.remove("disabled");
      submitButtonRef.current.removeEventListener("click", alertEvent);
    }
  });

  return (
    <div id="contents" className="subWrap">
      <h1>
        <Link to="/" onClick="window.location.reload()">
          찰떡궁합 MBTI
          <img src={logoImg} alt="logo" />
        </Link>
      </h1>
      <div className="selectWrapper">
        <div className="mbtiGroup">
          <h3>나의 MBTI</h3>
          <div className="selectBox" ref={selectMyRef}>
            <button
              type="button"
              value="mbti"
              ref={selectMyButtonRef}
              onClick={() => {
                selectMyRef.current.classList.toggle("active");
              }}
              className="selectButton"
            >
              {selectMyState}
            </button>
            <ul className="mbtiList">
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler} value="INTJ">
                  INTJ
                </button>
              </li>
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler} value="INTP">
                  INTP
                </button>
              </li>
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler} value="ENTJ">
                  ENTJ
                </button>
              </li>
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler} value="ENTP">
                  ENTP
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler} value="INFJ">
                  INFJ
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler} value="INFP">
                  INFP
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler} value="ENFJ">
                  ENFJ
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler} value="ENFP">
                  ENFP
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler} value="ISTJ">
                  ISTJ
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler} value="ISFJ">
                  ISFJ
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler} value="ESTJ">
                  ESTJ
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler} value="ESFJ">
                  ESFJ
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler} value="ISTP">
                  ISTP
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler} value="ISFP">
                  ISFP
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler} value="ESTP">
                  ESTP
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler} value="ESFP">
                  ESFP
                </button>
              </li>
            </ul>
          </div>
        </div>
        <span>+</span>
        <div className="mbtiGroup">
          <h3>상대방 MBTI</h3>
          <div className="selectBox" ref={selectYourRef}>
            <button
              type="button"
              value="mbti"
              ref={selectYourButtonRef}
              onClick={() => {
                selectYourRef.current.classList.toggle("active");
              }}
              className="selectButton"
            >
              {selectYourState}
            </button>
            <ul className="mbtiList">
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler2} value="INTJ">
                  INTJ
                </button>
              </li>
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler2} value="INTP">
                  INTP
                </button>
              </li>
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler2} value="ENTJ">
                  ENTJ
                </button>
              </li>
              <li className="mbtiPurple">
                <button onClick={selectBoxHandler2} value="ENTP">
                  ENTP
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler2} value="INFJ">
                  INFJ
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler2} value="INFP">
                  INFP
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler2} value="ENFJ">
                  ENFJ
                </button>
              </li>
              <li className="mbtiGreen">
                <button onClick={selectBoxHandler2} value="ENFP">
                  ENFP
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler2} value="ISTJ">
                  ISTJ
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler2} value="ISFJ">
                  ISFJ
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler2} value="ESTJ">
                  ESTJ
                </button>
              </li>
              <li className="mbtiBlue">
                <button onClick={selectBoxHandler2} value="ESFJ">
                  ESFJ
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler2} value="ISTP">
                  ISTP
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler2} value="ISFP">
                  ISFP
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler2} value="ESTP">
                  ESTP
                </button>
              </li>
              <li className="mbtiYellow">
                <button onClick={selectBoxHandler2} value="ESFP">
                  ESFP
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="btnBox disabled" ref={submitButtonRef}>
        <Link to="/result">결과화면</Link>
      </div>
    </div>
  );
}

export default SelectPage;
